import { faCheck, faClose, faPencil, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Column } from 'primereact/column'
import { classNames } from 'primereact/utils'
import { InputTextarea } from 'primereact/inputtextarea'
import { MultiSelect } from 'primereact/multiselect'
import { Toast } from 'primereact/toast'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectCertDetailValues,
  selectModelDetailValues,
  selectModelList,
  selectOwnerReference,
  selectPartySiteNumber,
  setModelsProductStandardsUpdates,
  selectStandardValue,
  selectStandardOptions,
  selectProductCategoryStandards,
  updateHasExistingModels,
  updateModelDetails,
  updateModelList,
  updateProdDetailsModelList,
  updateProdDetailsRemarks,
  updateStandardValues,
  updateHasEmptyProductStandardRow,
  updateCertDetailsFormValues,
  selectSchemeEcmType,
  updateTempStandardOptions,
  updateIsModelOnEdit,
  selectedCertHasSecondary as selectCertHasSecondary,
  updateSecondaryStandardValues,
  updateTempSecondaryStandardOptions,
  selectSecondaryStandardOptions,
  selectSelectedProductCategory,
  selectSecondaryStandardValue,
  selectCopyState,
} from '../../../../../features/createCertificate/createCertificateSlice'
import DocumentService from '../../../../../services/DocumentService'
import ModelSearch from '../../../../../shared/model-search/ModelSearch'
import { sortList } from '../../../../../utils/helpers/array.helpers'
import classes from './AddNewCertProdDetails.module.scss'
import './AddNewCertProdDetails.scss'
import CloseRowEditModeConfirmationDialog from './close-row-edit-mode-confirmation-dialog/CloseRowEditModeConfirmationDialog'
import AddAttachmentsBulkV2 from '../add-attachments-bulk-v2/AddAttachmentsBulkV2'
import BulkSaveConfirmationDialog from './bulk-save-confirmation-dialog/BulkSaveConfirmationDialog'
import { uniqBy, orderBy, flatten } from 'lodash'
import AddAttachmentsRP from '../rp-library/add-attachments-rp/AddAttachmentsRP'
import { SchemeEcmType } from '../../../../../enums/SchemeEcmType'
import {
  getAttributeUniqueName,
  CertificateGroupEnum,
} from '../../../../../utils/constants/certificate.constants'
import SecondaryStandardTemplate from './secondary-standard-template/SecondaryStandardTemplate'
import { ProductStandardUtils } from './utils/product-standard-utils'

const AddNewCertProdDetails = props => {
  const dispatch = useDispatch()
  const certDetailsValues = useSelector(selectCertDetailValues)
  const {
    isSavingCertificate,
    isEditCert,
    isModifyCert,
    setOutputAttachmentValues,
    setFormValues,
    certificateId,
    currentStep,
    setIsModelInRowEditMode,
    setFormValidityMessages,
    inputAttachments,
    setAttachments,
    isCertificateHaveStandard,
    testReportsValidatorHook,
    setIsAttachmentsValid,
    projectDetailsValues,
    hasRevisions,
    rpAttachments,
    setRPAttachments,
    updateRPAttachmentOnParent,
    uniqueCertificateId,
    isAutoGenerate,
    certificateNumber,
  } = props
  const [selectedModels, setSelectedModels] = useState([])
  const [selectedModelsForDeletion, setSelectedModelsForDeletion] = useState([])

  const [remarks, setRemarks] = useState('')
  const partySiteNumberValue = useSelector(selectPartySiteNumber)
  const modelDetailValues = useSelector(selectModelDetailValues)
  const ownerReference = useSelector(selectOwnerReference)
  const models = useSelector(selectModelList)
  const standardValue = useSelector(selectStandardValue)
  const standardOptions = useSelector(selectStandardOptions)
  const secondaryStandardOptions = useSelector(selectSecondaryStandardOptions)
  const standardOptionsClone = useSelector(selectProductCategoryStandards)
  const secondaryStandardValue = useSelector(selectSecondaryStandardValue)
  const schemeEcmType = useSelector(selectSchemeEcmType)
  const certHasSecondary = useSelector(selectCertHasSecondary)
  const productType = useSelector(selectSelectedProductCategory)
  const isCopyModel = useSelector(selectCopyState)

  const [modelSearchVisible, setModelSearchVisible] = useState(false)
  const [modelList, setModelList] = useState(models ? models : [])
  const [standardList, setStandardList] = useState([])

  const [isBatchEditMode, setIsBatchEditMode] = useState(false)
  const batchEditRowData = {
    isEditMode: true,
    productStandards: [],
    isForBatchEdit: true,
  }

  const [modelsProductStandardsEditStates, setModelsProductStandardsEditStates] = useState([])

  const rowsInEditMode = modelList?.filter(model => model.isEditMode)
  const hasRowEditMode = rowsInEditMode?.length > 0 || isBatchEditMode
  const [closeRowEditModeConfirmationDialogVisible, setCloseRowEditModeConfirmationDialogVisible] =
    useState(false)
  const [pendingCloseRowsEditModesConfirmation, setPendingCloseRowsEditModesConfirmation] =
    useState([])
  const [bulkSaveConfirmationDialogVisible, setBulkSaveConfirmationDialogVisible] = useState(false)
  const [pendingBulkSaveEditModesConfirmation, setPendingBulkSaveEditModesConfirmation] = useState(
    []
  )

  const toast = useRef(null)
  const selectedModelsCount = selectedModels.length

  useEffect(() => {
    setIsModelInRowEditMode(hasRowEditMode)
  }, [])

  useEffect(() => {
    const modelDetail = {}
    if (models && models.length > 0) {
      let partySiteNumber = ''

      for (let i = 0; i < models.length; i++) {
        let isExists = models[i].taxonomy.find(
          f => f.dataParamName === 'ownerReference_PartySiteID'
        )

        if (isExists) {
          partySiteNumber = isExists.value
          break
        }
      }

      modelDetail.partySiteNumber = partySiteNumber
      modelDetail.productType = models[0].productType
      modelDetail.isDisable = true
    } else {
      modelDetail.partySiteNumber = ownerReference
      modelDetail.productType = null
      modelDetail.isDisable = false
    }

    dispatch(updateModelDetails(modelDetail))
    setModelList(models)
  }, [models, ownerReference])

  useEffect(() => {
    if (modelList.length > 0 && currentStep === 3) {
      const disableProductStandardSaveActivate = !modelList?.some(x => x.productStandards?.length)

      dispatch(updateHasEmptyProductStandardRow(disableProductStandardSaveActivate))
    }
  }, [currentStep])

  useEffect(() => {
    props.onSetRowEditMode && props.onSetRowEditMode(hasRowEditMode)
  }, [hasRowEditMode])

  useEffect(() => {
    if (!productType) return
    if (currentStep !== 2) return

    /**
     * Resetting this state when product type changed in step 2.
     */
    setModelsProductStandardsEditStates(prev =>
      prev.map(item => ({
        ...item,
        productStandards: [],
      }))
    )
  }, [productType])

  const mapper = standard => {
    return {
      pkSchemeScopeStandardId:
        standard.schemeScopeStandardId ??
        standard.value?.pkSchemeScopeStandardId ??
        standard.uniqueIdentifier ??
        standard.pkSchemeScopeStandardId,
      pkStandardId: standard.standardId,
      pkStandardLabelId: standard.standardLabelId,
      seq: standard.sequence,
      standardLevel: standard.standardLevel,
    }
  }

  const modelSecondaryStandardTemplate = model => {
    const isDisabled = isBatchEditMode ? !model.isForBatchEdit : !isModelSelected(model.assetId)

    return (
      <div
        onClick={event => event.stopPropagation()}
        className={classes['product-standards-container']}
      >
        <SecondaryStandardTemplate
          {...{
            isEditMode: model.isEditMode,
            isBatchEditMode,
            modelList,
          }}
          model={model}
          selectedModels={selectedModels}
          key={`${model.isEditMode || isBatchEditMode ? 'update' : 'static'}-${model.modelName}`}
          slotProps={{
            multiSelect: {
              className: classes['standards-dropdown'],
              disabled: isDisabled,
              onChange: selectedValues => {
                setModelsProductStandardsEditStates(prev => {
                  const prevCopy = structuredClone(prev)
                  const toUpdate = prevCopy.find(item => item.assetId === model.assetId)

                  if (!toUpdate) return prev
                  toUpdate.secondaryStandards = selectedValues
                  return prevCopy
                })
              },
            },
          }}
        />
      </div>
    )
  }

  const columns = [
    {
      id: 'modelName',
      value: 'Model',
      width: '20%',
      body: modelNameTemplate,
    },
    {
      id: 'productType',
      value: 'Product Type',
      width: '20%',
    },
    {
      id: 'productStandard',
      value: 'Product Standard',
      width: '25%',
      body: modelProductStandardsTemplate,
    },
    {
      id: 'secondaryStandard',
      value: 'Secondary Standard',
      width: '25%',
      body: modelSecondaryStandardTemplate,
    },
    {
      id: 'familySeries',
      value: 'Family / Series',
      width: '20%',
    },
    {
      id: 'status',
      value: 'Status',
      width: '10%',
    },
  ]

  const onChangeRemarks = event => {
    setRemarks(event.target.value)
    dispatch(updateProdDetailsRemarks(event.target.value))
  }

  const dynamicColumns = columns
    .filter(col => {
      switch (col.id) {
        case 'secondaryStandard':
          return certHasSecondary
      }
      return true
    })
    .map(col => {
      const { id, value, width, ...rest } = col

      return (
        <Column key={id} columnKey={id} field={id} header={value} style={{ width }} {...rest} />
      )
    })

  const handleSelectedModelsApply = (selectedModels, isClose) => {
    dispatch(updateProdDetailsModelList(selectedModels))
    dispatch(updateHasExistingModels(false))
    dispatch(updateModelList(selectedModels))
    setModelList(selectedModels)

    if (isClose) setModelSearchVisible(false)
  }

  const onClickDeleteModelHeader = () => {
    setModelList(prevState => {
      let newState = []

      prevState.forEach(item => {
        let foundSelected = selectedModels.find(i => i.assetId === item.assetId)
        if (!foundSelected) {
          newState.push(item)
        }
      })

      if (newState.length === 0) {
        const modelDetail = {
          partySiteNumber: partySiteNumberValue,
          productType: null,
          isDisable: false,
        }

        dispatch(updateModelDetails(modelDetail))
      }

      dispatch(updateProdDetailsModelList(newState))
      return newState
    })

    setSelectedModels([])
  }

  const onClickDeleteModelRow = assetId => {
    setModelList(prevState => {
      const newState = prevState.filter(i => i.assetId !== assetId)

      if (newState.length === 0) {
        const modelDetail = {
          partySiteNumber: partySiteNumberValue,
          productType: null,
          isDisable: false,
        }

        dispatch(updateModelDetails(modelDetail))
      }

      dispatch(updateProdDetailsModelList(newState))
      dispatch(updateModelList(newState))

      return newState
    })
  }

  const setEditMode = (isEditMode, model) => {
    if (isEditMode) {
      if (!selectedModels.some(selectedModel => selectedModel.assetId === model.assetId)) {
        setSelectedModels(prevList => [...prevList, model])
      }

      updateModelProductStandardsEditState(model.assetId, model.productStandards)
    }

    setModelList(prevList =>
      prevList.map(prevModel => ({
        ...prevModel,
        isEditMode: prevModel.assetId === model.assetId ? isEditMode : prevModel.isEditMode,
      }))
    )

    setStandardList(standardOptions)
    // dispatch(updateStandardOptions(standardOptionsClone));
    dispatch(updateIsModelOnEdit(true))
  }

  const updateModelProductStandardsEditState = (assetId, newValues) => {
    if (modelsProductStandardsEditStates.some(model => model.assetId === assetId)) {
      setModelsProductStandardsEditStates(prevList =>
        prevList.map(item => ({
          ...item,
          productStandards: item.assetId === assetId ? newValues : item.productStandards,
        }))
      )

      return
    }

    setModelsProductStandardsEditStates(prevList => [
      ...prevList,
      { assetId, productStandards: newValues },
    ])
  }

  const handleModelProductStandardsEditChange = (e, newProductStandardOptions, assetId) => {
    e.originalEvent.stopPropagation()
    const newValues = newProductStandardOptions.filter(option => e.value.includes(option.code))

    updateModelProductStandardsEditState(assetId, newValues)
  }

  const getModelProductStandardsEditState = assetId =>
    (
      modelsProductStandardsEditStates.find(model => model.assetId === assetId)?.productStandards ||
      []
    ).filter(ProductStandardUtils.filterListByStandard)

  const getModelProductSecondaryStandardsEditState = assetId =>
    (
      modelsProductStandardsEditStates.find(model => model.assetId === assetId)?.productStandards ||
      []
    ).filter(ProductStandardUtils.filterListBySecondaryStandard)

  const certProductStandardOptions =
    certDetailsValues.standardOptions?.map(option => ({
      ...option,
      ...option.otherProps,
    })) || []

  const certSecondaryProductStandardOptions =
    certDetailsValues.secondaryStandardOptions?.map(option => ({
      ...option,
      ...option.otherProps,
    })) || []

  function setModelProductStandards(assetId, productStandards) {
    setModelList(previousList =>
      previousList.map(prevModel => ({
        ...prevModel,
        productStandards:
          prevModel.assetId === assetId ? productStandards : prevModel.productStandards,
        originalProductStandards:
          prevModel.assetId === assetId ? productStandards : prevModel.originalProductStandards,
      }))
    )
  }

  const handleProductStandardRemove = (assetId, code) => {
    const newProductStandards = getModelProductStandardsEditState(assetId).filter(
      standard => standard.code !== code
    )

    updateModelProductStandardsEditState(assetId, newProductStandards)
    dispatch(updateStandardValues(standardValue.filter(standard => standard !== code)))
  }

  const selectedProductStandardTemplate = (assetId, productStandard) => {
    let selectedItemsCount = getModelProductStandardsEditState(assetId).length

    if (selectedItemsCount === 0 || !Boolean(productStandard)) {
      return (
        <span className={classes['product-standard__placeholder']}>
          {primaryStandardPlaceholder}
        </span>
      )
    }

    return (
      <div className={classes['product-standard--selected']}>
        <label>{productStandard?.name}</label>

        {productStandard?.name && (
          <button
            onClick={e => {
              e.stopPropagation()
              handleProductStandardRemove(assetId, productStandard.code)
            }}
          >
            {isModelSelected(assetId) && <FontAwesomeIcon icon={faClose} />}
          </button>
        )}
      </div>
    )
  }

  function modelNameTemplate(model) {
    if (model.isForBatchEdit) {
      return (
        <div className={classes['batch-edit-row-model-name']}>
          Note: Selected Product Standards in this row will apply <br></br>
          to all selected models.
        </div>
      )
    }

    return model.modelName
  }

  const primaryStandardPlaceholder =
    (standardOptions ?? []).length <= 0
      ? `None available for ${productType}`
      : '-- Select Product Standard(s) --'

  function modelProductStandardsTemplate(model) {
    const modelStandard = (
      model.isForBatchEdit
        ? (modelList ?? []).flatMap(item => item.productStandards)
        : (model.productStandards ?? [])
    )
      .filter(ProductStandardUtils.filterListByStandard)
      .map(ProductStandardUtils.mapStandardByValue)

    if (model.loadingProductStandards) {
      return (
        <div className={`${classes['product-standards-container--loading']}`}>
          <FontAwesomeIcon icon={faSpinner} spin={true} />
        </div>
      )
    }

    if (
      (model.isEditMode || isBatchEditMode) &&
      (selectedModels.map(x => x.assetId).includes(model.assetId) || !model?.assetId)
    ) {
      let newProductStandardOptions = uniqBy(
        [...modelStandard, ...certProductStandardOptions],
        standard => standard.code
      )

      newProductStandardOptions = orderBy(newProductStandardOptions, ['name'], ['asc'])

      const isProductStandardsSelectionDisabled = isBatchEditMode
        ? !model.isForBatchEdit
        : !isModelSelected(model.assetId)

      let selectedValues = getModelProductStandardsEditState(model.assetId)

      return (
        <div
          className={`${classes['product-standards-container']}`}
          onClick={e => {
            e.stopPropagation()
          }}
        >
          <MultiSelect
            disabled={isProductStandardsSelectionDisabled}
            selectedItemTemplate={code => {
              const selectedProductStandard = newProductStandardOptions.find(
                standard => standard.code === code
              )

              return selectedProductStandardTemplate(model.assetId, selectedProductStandard)
            }}
            onChange={e => {
              handleModelProductStandardsEditChange(e, newProductStandardOptions, model.assetId)
            }}
            value={selectedValues.map(standard => standard.code)}
            filter={true}
            optionLabel="name"
            optionValue="code"
            options={newProductStandardOptions}
            placeholder={primaryStandardPlaceholder}
            className={`${classes['standards-dropdown']}`}
          />
        </div>
      )
    }

    const productStandardsTooltip = modelStandard
      ?.map(productStandard => productStandard.name)
      .join(' \n')

    const maxDisplay = 5
    const sortedProductStandards = sortList(modelStandard || [], 'name', 1) || []
    const topSortedProductStandards = [...sortedProductStandards].slice(0, maxDisplay)

    return (
      <div className={`${classes['product-standards-container']}`} title={productStandardsTooltip}>
        {topSortedProductStandards.map(productStandard => (
          <div key={productStandard.code}>{productStandard.name}</div>
        ))}
      </div>
    )
  }

  const handleEditHeaderClick = () => {
    const selectedModelsProductStandards = flatten(selectedModels.map(x => x.productStandards))

    const uniqueSelectedProductStandards = uniqBy(
      selectedModelsProductStandards,
      standard => standard.code
    )

    updateModelProductStandardsEditState(undefined, uniqueSelectedProductStandards)

    modelList.forEach(model =>
      updateModelProductStandardsEditState(model.assetId, model.productStandards)
    )
    setIsBatchEditMode(true)

    setStandardList(standardOptions)
    // dispatch(updateStandardOptions(standardOptionsClone));
    dispatch(updateIsModelOnEdit(true))
  }

  const renderModelsActionsHeader = () => {
    const isSelectedMoreThan1 = selectedModels?.length > 1
    const isBatchActionsDisabled = !isSelectedMoreThan1 || hasRowEditMode

    return (
      <div className={`${classes['actions-container']} ${classes['actions-container--header']}`}>
        <button
          title="Edit Selected"
          disabled={isBatchActionsDisabled}
          onClick={handleEditHeaderClick}
          className={classes['action-button']}
        >
          <FontAwesomeIcon icon={faPencil} />
        </button>

        <button
          title="Delete Selected"
          disabled={isBatchActionsDisabled}
          className={classes['action-button']}
          onClick={onClickDeleteModelHeader}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    )
  }

  const handleBulkSaveRowsEdit = () => {
    if (modelList.length !== selectedModels.length) {
      setBulkSaveConfirmationDialogVisible(true)
      setPendingBulkSaveEditModesConfirmation(models)
      return
    }

    handleSaveRowsEdit(selectedModels)
  }

  const handleBulkSaveConfirmationConfirm = () => {
    setBulkSaveConfirmationDialogVisible(false)
    handleSaveRowsEdit(pendingBulkSaveEditModesConfirmation)
  }

  const handleBulkSaveConfirmationNoCancel = () => {
    setBulkSaveConfirmationDialogVisible(false)
  }

  const handleCloseRowEditMode = models => {
    setCloseRowEditModeConfirmationDialogVisible(true)
    setPendingCloseRowsEditModesConfirmation(models)
  }

  const handleSaveRowsEdit = models => {
    models.forEach(model => {
      setEditMode(false, model)

      if (!isModelSelected(model.assetId)) return

      const assetId = isBatchEditMode ? undefined : model.assetId

      const modelProductStandards = modelsProductStandardsEditStates.find(
        item => item.assetId === assetId
      )

      const secondaryStandardChanges =
        modelProductStandards.secondaryStandards ?? // not undefined once secondary has changes
        (model.productStandards ?? [])
          .filter(ProductStandardUtils.filterListBySecondaryStandard)
          .map(ProductStandardUtils.mapStandardByValue) // retain original secondary values;

      const newProductStandards = (modelProductStandards?.productStandards ?? [])
        .filter(ProductStandardUtils.filterListByStandard)
        .map(ProductStandardUtils.mapStandardByValue)

      setModelList(previousList => {
        const newModelList = previousList.map(prevModel => ({
          ...prevModel,
          productStandards:
            prevModel.assetId === model.assetId
              ? uniqBy(
                  [
                    ...newProductStandards,
                    ...secondaryStandardChanges.filter(item =>
                      (secondaryStandardOptions ?? []).some(option => item.code === option.code)
                    ), // catch not iterable exception
                  ],
                  'code'
                )
              : prevModel.productStandards,
        }))

        const newCertificateProductStandards = props.isCertificateHaveStandard
          ? uniqBy(
              newModelList.flatMap(model => model.productStandards || []),
              'code'
            )
          : null

        //#region sync all model standards
        const standardsUpdate = props.isCertificateHaveStandard
          ? newProductStandards.map(item => item.code)
          : null
        const secondaryStandardsUpdate = secondaryStandardChanges.map(item => item.code)

        const prevProductStandards = newModelList.flatMap(item => item.productStandards ?? [])
        const prevStandards = prevProductStandards
          .filter(ProductStandardUtils.filterListByStandard)
          .map(ProductStandardUtils.mapStandardByValue)
          .map(item => item.code)
        const prevSecondaryStandards = prevProductStandards
          .filter(ProductStandardUtils.filterListBySecondaryStandard)
          .map(ProductStandardUtils.mapStandardByValue)
          .map(item => item.code)

        const newStandards = [...new Set([...standardsUpdate, ...prevStandards])]
        const newSecondaryStandards = [
          ...new Set([...secondaryStandardsUpdate, ...prevSecondaryStandards]),
        ]
        //#endregion

        setFormValues(prevState => {
          const newState = {
            ...prevState,
            [getAttributeUniqueName(CertificateGroupEnum.Certificate, 'standard')]: newStandards,
            [getAttributeUniqueName(CertificateGroupEnum.Certificate, 'secondaryStandard')]:
              newSecondaryStandards,
          }

          dispatch(updateCertDetailsFormValues(newState))
          return newState
        })

        setFormValidityMessages(prevState => {
          let newState = JSON.parse(JSON.stringify(prevState))
          newState[getAttributeUniqueName(CertificateGroupEnum.Certificate, 'standard')] = ''
          return newState
        })

        const newCertProductStandardOptions = uniqBy(
          [...certProductStandardOptions, ...(newCertificateProductStandards ?? [])],
          option => option.code
        )

        dispatch(updateStandardValues(newStandards))
        dispatch(updateSecondaryStandardValues(newSecondaryStandards))

        // dispatch(updateStandardOptions(newCertProductStandardOptions));
        dispatch(updateTempStandardOptions(newCertProductStandardOptions))
        dispatch(updateTempSecondaryStandardOptions(secondaryStandardOptions))

        return newModelList
      })
    })

    unselectModels(models)
    setPendingBulkSaveEditModesConfirmation([])
    setIsBatchEditMode(false)
    dispatch(updateIsModelOnEdit(false))
  }

  const actionsRowTemplate = model => {
    const isEditModeDisabled = !isModelSelected(model.assetId) && !model.isForBatchEdit

    const isSaveProductStandardsDisabled = model.isForBatchEdit && selectedModels.length === 0

    return (
      <div className={classes['actions-container']}>
        {model.isEditMode && (
          <>
            <button
              title="Save"
              onClick={e => {
                if (isSaveProductStandardsDisabled) return
                onProductStandardRowEditClick(e, model, false)
              }}
              className={classNames(
                classes['action-button'],
                classes['btn-edit-mode--check'],
                isEditModeDisabled || isSaveProductStandardsDisabled
                  ? classes['btn-edit-mode--check-disabled']
                  : ''
              )}
            >
              <FontAwesomeIcon size="lg" icon={faCheck} />
            </button>

            <button
              title="Cancel"
              onClick={e => onProductStandardRowEditClick(e, model, true)}
              className={classNames(
                isEditModeDisabled ? classes['btn-edit-mode--check-disabled'] : '',
                classes['action-button'],
                classes['btn-edit-mode--close']
              )}
            >
              <FontAwesomeIcon size="lg" icon={faClose} />
            </button>
          </>
        )}

        {!model.isEditMode && !isBatchEditMode && (
          <button
            title="Edit Product Standard"
            onClick={e => {
              e.stopPropagation()
              setEditMode(true, model)
            }}
            disabled={selectedModels?.length > 1}
            className={classes['action-button']}
          >
            <FontAwesomeIcon icon={faPencil} />
          </button>
        )}

        {!model.isForBatchEdit && !isBatchEditMode && !model.isEditMode && (
          <button
            title="Delete Model"
            className={classes['action-button']}
            disabled={selectedModels?.length > 1}
            onClick={e => {
              e.stopPropagation()
              onClickDeleteModelRow(model.assetId)
            }}
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        )}
      </div>
    )
  }

  const hasModel = modelList?.length > 0

  const onProductStandardRowEditClick = (event, model, isClose) => {
    event.stopPropagation()

    if (!isModelSelected(model.assetId) && !model.isForBatchEdit) return

    if (isClose) {
      handleCloseRowEditMode([model])
      return
    }

    if (model.isForBatchEdit) {
      handleBulkSaveRowsEdit()
      return
    }

    handleSaveRowsEdit([model])
  }

  const handleCloseRowEditModeConfirmationConfirm = () => {
    setCloseRowEditModeConfirmationDialogVisible(false)

    pendingCloseRowsEditModesConfirmation.forEach(row => {
      setEditMode(false, row)
    })

    // dispatch(updateStandardOptions(standardList));
    unselectModels(pendingCloseRowsEditModesConfirmation)
    setIsBatchEditMode(false)
    dispatch(updateIsModelOnEdit(false))
  }

  const unselectModels = models => {
    setSelectedModels(prevSelectedModels =>
      prevSelectedModels.filter(
        selectedModel => !models.map(model => model.assetId).includes(selectedModel.assetId)
      )
    )
  }

  const handleCloseRowEditModeConfirmationNoCancel = () => {
    setCloseRowEditModeConfirmationDialogVisible(false)
  }

  const isModelSelected = assetId => {
    if (selectedModels.length === 0) return

    return selectedModels.some(selectedModel => selectedModel.assetId === assetId)
  }

  const isModelSelectable = model => {
    return !model.data.isForBatchEdit
  }

  const frozenRows = isBatchEditMode ? [batchEditRowData] : []

  const isCertificateFromRevision = () => {
    return isEditCert && (hasRevisions || isModifyCert)
  }

  const handleModelSelectionChange = e => {
    if (!hasRowEditMode) setSelectedModels(e.value)
    else if (isBatchEditMode) setSelectedModels(e.value)
  }

  const isEditOrModify = isEditCert || isModifyCert

  return (
    <>
      <Toast ref={toast} />
      <CloseRowEditModeConfirmationDialog
        onCancel={handleCloseRowEditModeConfirmationNoCancel}
        onConfirm={handleCloseRowEditModeConfirmationConfirm}
        visible={closeRowEditModeConfirmationDialogVisible}
        maskClassName={classes['custom-dialog']}
      />

      <BulkSaveConfirmationDialog
        selectedModelsCount={selectedModelsCount}
        onCancel={handleBulkSaveConfirmationNoCancel}
        onConfirm={handleBulkSaveConfirmationConfirm}
        visible={bulkSaveConfirmationDialogVisible}
        maskClassName={classes['custom-dialog']}
      />

      <ModelSearch
        visible={modelSearchVisible}
        onClose={() => setModelSearchVisible(false)}
        onSelectedModelsApply={handleSelectedModelsApply}
        partySiteNumber={
          hasModel
            ? modelList[0].taxonomy.find(m => m.dataParamName === 'ownerReference_PartySiteID')
                .value
            : modelDetailValues?.partySiteNumber
        }
        productType={hasModel ? modelList[0].productType : modelDetailValues?.productType}
        disablePsn={hasModel}
        disableProductType={hasModel}
        preSelectedModels={modelList}
        certificateId={certificateId}
      />

      <div
        className={
          isSavingCertificate ? 'display-none' : classes['add-new-cert-prod-details-modal']
        }
      >
        <div
          className={`${hasRowEditMode ? classes['disabled-section'] : classes['ul-grid__div']}`}
        >
          <div className="ul-grid__row attachment-row">
            <div className="ul-grid__column">
              {schemeEcmType === SchemeEcmType.RP && (
                <AddAttachmentsRP
                  projectDetailsValues={projectDetailsValues}
                  certDetailsValues={certDetailsValues}
                  isCertificateFromRevision={isCertificateFromRevision()}
                  rpAttachments={rpAttachments}
                  setRPAttachments={setRPAttachments}
                  updateRPAttachmentOnParent={updateRPAttachmentOnParent}
                  certificateId={certificateId}
                  isEditOrModify={isEditOrModify}
                  uniqueCertificateId={uniqueCertificateId}
                  isAutoGenerate={isAutoGenerate}
                  certificateNumber={certificateNumber}
                  currentStep={currentStep}
                />
              )}
              {schemeEcmType !== SchemeEcmType.RP && (
                <AddAttachmentsBulkV2
                  setAttachments={setAttachments}
                  setOutputAttachmentValues={setOutputAttachmentValues}
                  inputAttachments={inputAttachments}
                  hasAttachmentLabel={true}
                  testReportsValidatorHook={testReportsValidatorHook}
                  setIsAttachmentsValid={setIsAttachmentsValid}
                  isEditOrModify={isEditOrModify}
                  certificateId={certificateId}
                  isCertificateFromRevision={isCertificateFromRevision}
                  currentStep={currentStep}
                  uniqueCertificateId={uniqueCertificateId}
                />
              )}
            </div>
          </div>

          <div className="ul-grid__row remarks-row">
            <div className={`${classes['new-cert-prod-dtls-rmrks-div']} ul-grid__column`}>
              <div className={classes['new-cert-prod-dtls-col-hdr']}>Remarks</div>
              <div className={classes['remarks-text-area-div']}>
                <InputTextarea
                  disabled={hasRowEditMode}
                  className={classes['remarks-text-area']}
                  value={remarks}
                  onChange={onChangeRemarks}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddNewCertProdDetails
